import React from 'react';
import Poppop from 'react-poppop';
import IndexSystemList from './IndexSystemList';

const AllSystemPopup = ({
    systemList, locale, close, open,
}) => (
    <Poppop
        onClose={close}
        open={open}
        closeBtn
        closeOnEsc
        closeOnOverlay
        contentStyle={{ maxWidth: '1000px', overflow: 'auto' }}
    >
        <IndexSystemList systemList={systemList} locale={locale} />
    </Poppop>
);

export default AllSystemPopup;
